import React from 'react';
import { ChevronUp, RefreshCw, Settings, SlidersHorizontal } from 'lucide-react';

// 评奖评优基准名单管理页面
// 对应图1。
// 页面结构：条件筛选卡片 + 结果卡片（新增/删除/工具按钮 + 基准名单表格 + 分页）
export default function BaselineRosterPage() {
  // ================= 页面数据 =================
  const rosterList = [
    {
      id: 1,
      name: '评奖评优基准名单',
      grades: '2024,2023,2022',
      studentTypes: '专科生,研究生',
      useStatus: '使用中',
      studentTotal: 76,
      createdAt: '2026-05-09 14:18',
      referenceAt: '2026-05-09 14:18',
      academicYear: '2025-2026',
      semester: '第二学期',
      generateStatus: '已生成',
    },
  ];

  return (
    <div className="animate-fade-in space-y-4">
      {/* 条件筛选卡片：按名单名称、创建时间、状态和学年学期查询 */}
      <div className="bg-white rounded shadow-sm border border-gray-100 p-5">
        <div className="grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 gap-x-8 gap-y-6">
          {/* 筛选项：名单名称 */}
          <FilterInput
            label="名单名称"
            placeholder="请输入"
          />

          {/* 筛选项：创建开始时间 */}
          <FilterInput
            label="创建开始时间"
            type="date"
          />

          {/* 筛选项：创建结束时间 */}
          <FilterInput
            label="创建结束时间"
            type="date"
          />

          {/* 筛选项：生成状态 */}
          <FilterSelect
            label="生成状态"
            placeholder="请输入"
          />

          {/* 筛选项：使用状态 */}
          <FilterSelect
            label="使用状态"
            placeholder="请输入"
          />

          {/* 筛选项：学年/学期 */}
          <FilterSelect
            label="学年/学期"
            placeholder=""
          />
        </div>

        {/* 查询按钮区 */}
        <div className="flex justify-end items-center gap-3 mt-6">
          <button className="px-5 py-2 border border-gray-300 text-gray-700 rounded text-sm hover:bg-gray-50">
            重置
          </button>
          <button className="px-5 py-2 bg-[#1890ff] text-white rounded text-sm hover:bg-[#096dd9]">
            查询
          </button>
          <button className="text-[#1890ff] text-sm flex items-center gap-1">
            收起
            <ChevronUp size={15} />
          </button>
        </div>
      </div>

      {/* 结果卡片：基准名单列表 */}
      <div className="bg-white rounded shadow-sm border border-gray-100 p-5">
        {/* 表格上方操作按钮区 */}
        <div className="flex justify-between items-center mb-4">
          <div className="flex gap-2">
            <button className="px-5 py-2 bg-[#1890ff] text-white rounded text-sm hover:bg-[#096dd9]">
              新增
            </button>
            <button className="px-5 py-2 border border-red-400 text-red-500 rounded text-sm hover:bg-red-50">
              删除
            </button>
          </div>

          {/* 表格工具按钮区 */}
          <TableToolbar />
        </div>

        {/* 基准名单表格 */}
        <div className="overflow-x-auto border border-gray-200 rounded">
          <table className="w-full text-left border-collapse text-[13px] text-gray-700 whitespace-nowrap min-w-max">
            <thead>
              <tr className="bg-[#fafafa] border-b border-gray-200">
                <th className="py-3 px-4 w-10">
                  <input type="checkbox" className="rounded border-gray-300" />
                </th>
                <th className="py-3 px-4 font-medium text-gray-800">序号</th>
                <th className="py-3 px-4 font-medium text-gray-800">名单名称</th>
                <th className="py-3 px-4 font-medium text-gray-800">包含年级</th>
                <th className="py-3 px-4 font-medium text-gray-800">包含学生类别</th>
                <th className="py-3 px-4 font-medium text-gray-800">使用状态</th>
                <th className="py-3 px-4 font-medium text-gray-800">学生总数</th>
                <th className="py-3 px-4 font-medium text-gray-800">创建时间</th>
                <th className="py-3 px-4 font-medium text-gray-800">基准参考时间</th>
                <th className="py-3 px-4 font-medium text-gray-800">学年</th>
                <th className="py-3 px-4 font-medium text-gray-800">学期</th>
                <th className="py-3 px-4 font-medium text-gray-800">生成状态</th>
                <th className="py-3 px-4 font-medium text-gray-800 sticky right-0 bg-[#fafafa] z-10 border-l border-gray-200">
                  操作
                </th>
              </tr>
            </thead>
            <tbody>
              {rosterList.map((row, index) => (
                <tr key={row.id} className="border-b border-gray-100 hover:bg-[#f8f9fa] group">
                  <td className="py-3 px-4">
                    <input type="checkbox" className="rounded border-gray-300" />
                  </td>
                  <td className="py-3 px-4">{index + 1}</td>
                  <td className="py-3 px-4">{row.name}</td>
                  <td className="py-3 px-4">{row.grades}</td>
                  <td className="py-3 px-4">{row.studentTypes}</td>
                  <td className="py-3 px-4">{row.useStatus}</td>
                  <td className="py-3 px-4">{row.studentTotal}</td>
                  <td className="py-3 px-4">{row.createdAt}</td>
                  <td className="py-3 px-4">{row.referenceAt}</td>
                  <td className="py-3 px-4">{row.academicYear}</td>
                  <td className="py-3 px-4">{row.semester}</td>
                  <td className="py-3 px-4">{row.generateStatus}</td>
                  <td className="py-3 px-4 sticky right-0 bg-white group-hover:bg-[#f8f9fa] z-10 border-l border-gray-100">
                    <button className="text-[#1890ff] mr-3 hover:underline">
                      查看
                    </button>
                    <button className="text-[#1890ff] hover:underline">
                      修改
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* 分页区 */}
        <SimplePagination total={rosterList.length} />
      </div>
    </div>
  );
}

// 条件筛选：输入框
function FilterInput({ label, placeholder = '', type = 'text' }) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-800 shrink-0 whitespace-nowrap">
        {label}：
      </span>
      <input
        type={type}
        placeholder={placeholder}
        className="border border-gray-300 rounded px-3 py-2 text-sm flex-1 min-w-0 outline-none focus:border-[#1890ff]"
      />
    </div>
  );
}

// 条件筛选：下拉框
function FilterSelect({ label, placeholder = '请输入' }) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-800 shrink-0 whitespace-nowrap">
        {label}：
      </span>
      <select className="border border-gray-300 rounded px-3 py-2 text-sm flex-1 min-w-0 outline-none focus:border-[#1890ff] bg-white text-gray-500">
        <option>{placeholder}</option>
      </select>
    </div>
  );
}

// 表格工具按钮
function TableToolbar() {
  return (
    <div className="flex items-center gap-4 text-gray-700">
      <button className="hover:text-[#1890ff]" title="刷新">
        <RefreshCw size={18} />
      </button>
      <button className="hover:text-[#1890ff]" title="密度">
        <SlidersHorizontal size={18} />
      </button>
      <button className="hover:text-[#1890ff]" title="设置">
        <Settings size={18} />
      </button>
    </div>
  );
}

// 简单分页：用于展示当前页、总条数、每页条数
function SimplePagination({ total }) {
  return (
    <div className="flex justify-end items-center mt-4 text-sm text-gray-700 gap-2">
      <span>
        第1-1条 / 共{total}条
      </span>
      <button className="text-gray-300 px-1">
        &lt;
      </button>
      <button className="px-2.5 py-1 border border-[#1890ff] text-[#1890ff] rounded">
        1
      </button>
      <button className="text-gray-300 px-1">
        &gt;
      </button>
      <select className="border border-gray-300 rounded px-2 py-1 outline-none bg-white">
        <option>10 条/页</option>
      </select>
    </div>
  );
}
